import { Iri } from 'lib/utils/iri';

export enum KomboIntegrationStatus {
    Enabled = 'enabled',
    Disabled = 'disabled',
}

export type KomboConnect = {
    link: string;
};

export type KomboIntegration = {
    id: string;
    externalReference: string;
    toolId: string;
    creator: Iri;
    createdAt: string;
    status: KomboIntegrationStatus;
    syncKomboCandidatesWithTalentsEnabled: boolean;
    syncKomboCandidatesUpdatedWithinMonths: number;
};

export type SupermetricsLoginLink = {
    loginUrl: string;
};

export type IntegrationJob = {
    id: string;
    name: string;
    jobCode: string | null;
    city: string | null;
    remoteId: string;
};

export type KomboPassthroughSettings = {
    toolId: string;
    enabled: boolean;
    configuration: Record<string, unknown>;
    fields: Array<Record<string, unknown>>;
};

export type UpdateKomboPassthroughSettingsPayload = {
    enabled: boolean;
    configuration: Record<string, unknown>;
    fields: Array<Record<string, unknown>>;
};
